// Minimal entry so Vite hashes and serves your compiled Tailwind CSS for the
// static landing page.
import "./index.css";

// Attribution only. Writes to sessionStorage and renders nothing, so the page
// stays fully readable by crawlers that do not execute JavaScript.
import { captureSignupSource } from "./utils/signupSource";

captureSignupSource();
